module.exports = __webpack_public_path__ + "img/news_banner.d4007472.jpg";